"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateWithBilling = exports.validate = undefined;

var _revalidate = require("revalidate");

var _creditcards = require("creditcards");

var creditCardCreateValidator = function creditCardCreateValidator(f, m) {
  return (0, _revalidate.createValidator)(function (message) {
    return function (value, allValues) {
      if (allValues.paymentMethod === "cc") {
        return f(message)(value, allValues);
      } else {
        return undefined;
      }
    };
  }, m);
};
var isValidState = (0, _revalidate.createValidator)(function (message) {
  return function (value, allValues) {
    if (!value && allValues["country"] === "IN") {
      return message;
    }
  };
}, function (field) {
  return field + " is required";
});
var validate = exports.validate = (0, _revalidate.combineValidators)({
  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting "I\'m not a robot" above'
  })
});

var validateWithBilling = exports.validateWithBilling = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: "This is who will be invoiced" }),
  postalCode: (0, _revalidate.isRequired)({ message: "Postal code is required" }),
  city: (0, _revalidate.isRequired)({ message: "City is required" }),
  country: (0, _revalidate.isRequired)({ message: "Country is required" }),
  captcha: (0, _revalidate.isRequired)({
    message: 'Please complete the captcha by selecting "I\'m not a robot" above'
  })
  // state: isValidState({ message: "State is required" }),
});


//////////////////
// WEBPACK FOOTER
// ./src/utils/paymentSettingsFormValidation.js
// module id = 1246
// module chunks = 0